import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

import AuthLayout from '../layouts/AuthLayout.vue'
import AppLayout from '../layouts/AppLayout.vue'

import RouteViewComponent from '../layouts/RouterBypass.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/:pathMatch(.*)*',
    redirect: { name: 'dashboard' },
  },
  {
    name: 'admin',
    path: '/',
    component: AppLayout,
    redirect: { name: 'dashboard' },
    meta: { requiresAuth: true },
    children: [
      {
        name: 'dashboard',
        path: 'dashboard',
        component: () => import('../pages/admin/dashboard/Dashboard.vue'),
        meta: { requiresAuth: true },
      },
      {
        name: 'facturacion',
        path: 'facturacion',
        component: () => import('../pages/facturacion/facturacion.vue'),
        meta: { requiresAuth: true },
      },

      {
        name: 'finanzas',
        path: 'finanzas',
        component: () => import('../pages/finanzas/finanzas.vue'),
        meta: { requiresAuth: true },
      },
      {
        name: 'administracion',
        path: 'administracion/:id',
        component: () => import('../pages/administracion/Administracion.vue'),
        meta: { requiresAuth: true },
      },
      {
        name: 'settings',
        path: 'settings/:id',
        component: () => import('../pages/settings/Settings.vue'),
        meta: { requiresAuth: true },
      },
      {
        name: 'settings-list',
        path: 'settings-list/:id',
        component: () => import('../pages/settings/SettingsList.vue'),
        meta: { requiresAuth: true },
      },
      {
        name: 'preferences',
        path: 'preferences',
        component: () => import('../pages/preferences/Preferences.vue'),
        meta: { requiresAuth: true },
      },
      {
        name: 'users',
        path: 'users',
        component: () => import('../pages/users/UsersPage.vue'),
        meta: { requiresAuth: true },
      },
      {
        name: 'products',
        path: 'products',
        component: () => import('../pages/products/ProductsPage.vue'),
        meta: { requiresAuth: true },
      },
      {
        name: 'ventas',
        path: 'ventas/:id',
        component: () => import('../pages/ventas/VentasPage.vue'),
        meta: { requiresAuth: true },
      },
      {
        name: 'compras',
        path: 'compras/:id',
        component: () => import('../pages/purchase/PurchasePage.vue'),
        meta: { requiresAuth: true },
      },
      {
        name: 'conciliar-sri',
        path: 'compras/:id/conciliar-sri',
        component: () => import('../pages/purchase/SriReconcilePage.vue'),
        meta: { requiresAuth: true },
      },
      {
        name: 'reports',
        path: 'reports/:id',
        component: () => import('../pages/reports/ReportsPage.vue'),
        meta: { requiresAuth: true },
      },
      {
        name: 'budgets',
        path: '/budgets',
        component: () => import('../pages/budgets/BudgetPage.vue'),
        meta: { requiresAuth: true },
      },
      {
        name: 'reminders',
        path: '/reminders',
        component: () => import('../pages/reminders/ReminderPage.vue'),
        meta: { requiresAuth: true },
      },
      {
        name: 'ingresos',
        path: 'ingresos/:id',
        component: () => import('../pages/ingresos/IngresosPage.vue'),
        meta: { requiresAuth: true },
      },
      {
        name: 'egresos',
        path: 'egresos/:id',
        component: () => import('../pages/egresos/EgresosPage.vue'),
        meta: { requiresAuth: true },
      },
      {
        name: 'notes',
        path: '/notes',
        component: () => import('../pages/notes/NotesPage.vue'),
        meta: { requiresAuth: true },
      },
      {
        name: 'firmas',
        path: 'firmas',
        component: () => import('../pages/firmas/FirmasPage.vue'),
        meta: { requiresAuth: true },
      },
      /*{
        name: 'projects',
        path: 'projects',
        component: () => import('../pages/projects/ProjectsPage.vue'),
      },
      {
        name: 'payments',
        path: '/payments',
        component: RouteViewComponent,
        children: [
          {
            name: 'payment-methods',
            path: 'payment-methods',
            component: () => import('../pages/payments/PaymentsPage.vue'),
          },
          {
            name: 'billing',
            path: 'billing',
            component: () => import('../pages/billing/BillingPage.vue'),
          },
          {
            name: 'pricing-plans',
            path: 'pricing-plans',
            component: () => import('../pages/pricing-plans/PricingPlans.vue'),
          },
        ],
      },
      {
        name: 'faq',
        path: '/faq',
        component: () => import('../pages/faq/FaqPage.vue'),
      },*/
    ],
  },
  {
    path: '/auth',
    component: AuthLayout,
    children: [
      {
        name: 'login',
        path: 'login',
        component: () => import('../pages/auth/Login.vue'),
        meta: { requiresAuth: false },
      },
      {
        name: 'signup',
        path: 'signup',
        component: () => import('../pages/auth/Signup.vue'),
        meta: { requiresAuth: false },
      },
      {
        name: 'recover-password',
        path: 'recover-password',
        component: () => import('../pages/auth/RecoverPassword.vue'),
        meta: { requiresAuth: false },
      },
      {
        name: 'recover-password-email',
        path: 'recover-password-email',
        component: () => import('../pages/auth/CheckTheEmail.vue'),
        meta: { requiresAuth: false },
      },
      {
        path: '',
        redirect: { name: 'login' },
      },
    ],
  },
  {
    name: '404',
    path: '/404',
    component: () => import('../pages/404.vue'),
    meta: { requiresAuth: false },
  },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    // For some reason using documentation example doesn't scroll on page navigation.
    if (to.hash) {
      return { el: to.hash, behavior: 'smooth' }
    } else {
      window.scrollTo(0, 0)
    }
  },
  routes,
})
export function initRouterGuards(auth: import('firebase/auth').Auth) {
  router.beforeEach((to, from, next) => {
    const requiresAuth = to.matched.some((record) => record.meta.requiresAuth)
    const currentUser = auth.currentUser
    if (requiresAuth && !currentUser) {
      next('/auth/login')
    } else if (currentUser && to.path.includes('/auth')) {
      next('/')
    } else {
      next()
    }
  })
}
export default router
